export const REPORTS_STATEMENTS_EVENTS = {
  REPORTS_VIEWED: 'Reports Viewed',
  REPORT_GENERATION_SUCCEEDED: 'Report Generation Succeeded',
  REPORT_GENERATION_FAILED: 'Report Generation Failed',
  REPORT_DOWNLOAD_SUCCEEDED: 'Report Download Succeeded',
  REPORT_DOWNLOAD_FAILED: 'Report Download Failed',
};

export const REPORTS_STATEMENTS_EVENTS_PARAMS = {
  DEFAULT_REPORT: 'default_report',
  REPORT_TYPE: 'report_type',
  FORMAT: 'format',
  ERROR_DESCRIPTION: 'error_description',
  GENERATION_TIME_MS: 'generation_time_ms',
} as const;

export const REPORTS_STATEMENTS_EVENTS_VALUES = {
  REPORT_TYPE: {
    REPORTS: 'Reports',
    ARCHIVE: 'Archive',
    STATEMENTS: 'Statements',
    STATEMENT: 'Statement',
    DIGEST: 'Digest',
  },
  GENERATION_REPORT_TYPE: {
    CUSTOM: 'custom',
  },
  DATE_RANGE: {
    CUSTOM: 'Custom',
    EXISTING: 'Existing',
  },
  FILE_FORMAT: {
    PDF: 'pdf',
    XLSX: 'xlsx',
    CSV: 'csv',
  },
} as const;

export type ReportType =
  typeof REPORTS_STATEMENTS_EVENTS_VALUES.REPORT_TYPE[keyof typeof REPORTS_STATEMENTS_EVENTS_VALUES.REPORT_TYPE];
export type FileFormat =
  typeof REPORTS_STATEMENTS_EVENTS_VALUES.FILE_FORMAT[keyof typeof REPORTS_STATEMENTS_EVENTS_VALUES.FILE_FORMAT];
export type TReportGenerationPayload = {
  report_type: string;
  date_range: string;
  format: string;
};

export const REPORTS_TABS = {
  REPORTS: 'reports',
  ARCHIVE: 'archive',
};